import {
  createSetupIntent,
  setDefaultPaymentMethod,
} from '../api/billing-service.ts';

export async function updatePaymentMethod({ stripe, card, agencyId }) {
  const { clientSecret } = await createSetupIntent({ agencyId });

  const { error, setupIntent } = await stripe.confirmCardSetup(clientSecret, {
    payment_method: { card },
  });

  if (error) {
    throw error;
  }

  return setDefaultPaymentMethod({
    agencyId,
    setupIntentId: setupIntent.id,
  });
}